/**
 * Yönetim panelinde seçilebilecek oyun dilleri.
 *
 * Liste, aktif sağlayıcıların (Drakon + Gold Palace) **ortak** desteklediği
 * dillerdir. Burada olmayan bir dil seçilirse backend onu sessizce Türkçe'ye
 * düşürür (bkz. backend/services/game_language.py) — yani panelde görünüp
 * aslında çalışmayan bir seçenek olmaması için liste dar tutulmuştur.
 *
 * Sağlayıcı kümeleri:
 *   Drakon      tr, en, ru, de, fr, es, ar
 *   Gold Palace en, ko, th, es, ja, pt, tr, de
 *   ScorpioPlay 21 dil (şu an kapalı; kesişimi daraltmıyor)
 */
export const GAME_LANGUAGES = [
  { value: 'tr', label: 'Türkçe' },
  { value: 'en', label: 'İngilizce' },
  { value: 'de', label: 'Almanca' },
  { value: 'es', label: 'İspanyolca' },
];

export const GAME_LANGUAGE_HINT = 'Yalnızca tüm aktif sağlayıcıların desteklediği diller listelenir.';

export default GAME_LANGUAGES;
